import api, { handleAPIErrors } from 'shared/api'

const CLEAR_DATA = 'ceoRemunerationComponents/CLEAR_DATA'
const FETCH_REQUEST = 'ceoRemunerationComponents/FETCH_REQUEST'
const FETCH_SUCCESS = 'ceoRemunerationComponents/FETCH_SUCCESS'
const FETCH_FAILURE = 'ceoRemunerationComponents/FETCH_FAILURE'
const FETCH_ABSOLUTE_ALIGNMENT_REQUEST = 'ceoRemunerationComponents/FETCH_ABSOLUTE_ALIGNMENT_REQUEST'
const FETCH_ABSOLUTE_ALIGNMENT_SUCCESS = 'ceoRemunerationComponents/FETCH_ABSOLUTE_ALIGNMENT_SUCCESS'
const FETCH_ABSOLUTE_ALIGNMENT_FAILURE = 'ceoRemunerationComponents/FETCH_ABSOLUTE_ALIGNMENT_FAILURE'
const FETCH_REM_VS_PERFORMANCE_REQUEST = 'ceoRemunerationComponents/FETCH_REM_VS_PERFORMANCE_REQUEST'
const FETCH_REM_VS_PERFORMANCE_SUCCESS = 'ceoRemunerationComponents/FETCH_REM_VS_PERFORMANCE_SUCCESS'
const FETCH_REM_VS_PERFORMANCE_FAILURE = 'ceoRemunerationComponents/FETCH_REM_VS_PERFORMANCE_FAILURE'
const FETCH_REM_VS_PERFORMANCE_PERCENTILE_REQUEST = 'ceoRemunerationComponents/FETCH_REM_VS_PERFORMANCE_PERCENTILE_REQUEST'
const FETCH_REM_VS_PERFORMANCE_PERCENTILE_SUCCESS = 'ceoRemunerationComponents/FETCH_REM_VS_PERFORMANCE_PERCENTILE_SUCCESS'
const FETCH_REM_VS_PERFORMANCE_PERCENTILE_FAILURE = 'ceoRemunerationComponents/FETCH_REM_VS_PERFORMANCE_PERCENTILE_FAILURE'

const initialState = {
  result: { },
  loaded: false,
  loading: false,
  absoluteAlignmentLoading: false,
  absoluteAlignmentLoaded: false,
  remVsPerformanceLoading: false,
  remVsPerformanceLoading: false,
  remVsPerformancePercentileLoaded: false,
  remVsPerformancePercentileLoading: false,
  errors: []
}

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function clearData() {
  return {
    type: CLEAR_DATA,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function fetchRemVsPerformanceRequest(payload = {}) {
  return {
    type: FETCH_REM_VS_PERFORMANCE_REQUEST,
  }
}

export function fetchAbsoluteAlignmentRequest(payload = {}) {
  return {
    type: FETCH_ABSOLUTE_ALIGNMENT_REQUEST,
  }
}

export function fetchAbsoluteAlignmentSuccess(payload) {
  return {
    type: FETCH_ABSOLUTE_ALIGNMENT_SUCCESS,
    payload
  }
}

export function fetchAbsoluteAlignmentFailure(errors = []) {
  return {
    type: FETCH_ABSOLUTE_ALIGNMENT_FAILURE,
    errors,
  }
}

export function fetchRemVsPerformanceSuccess(payload) {
  return {
    type: FETCH_REM_VS_PERFORMANCE_SUCCESS,
    payload,
  }
}

export function fetchRemVsPerformanceFailure(errors = []) {
  return {
    type: FETCH_REM_VS_PERFORMANCE_FAILURE,
    errors,
  }
}

export function fetchRemVsPerformancePercentileRequest(payload = {}) {
  return {
    type: FETCH_REM_VS_PERFORMANCE_PERCENTILE_REQUEST,
  }
}

export function fetchRemVsPerformancePercentileSuccess(payload) {
  return {
    type: FETCH_REM_VS_PERFORMANCE_PERCENTILE_SUCCESS,
    payload,
  }
}

export function fetchRemVsPerformancePercentileFailure(errors = []) {
  return {
    type: FETCH_REM_VS_PERFORMANCE_PERCENTILE_FAILURE,
    errors,
  }
}

export function clearCeoRemunerationComponents() {
  return (dispatch, _) => {
    dispatch(clearData())
  }
}

export function loadCeoRemunerationComponents(id, options = {}) {
  return (dispatch, getState) => {
    const state = getState()
    dispatch(fetchRequest())

    const promise = api(`api/v1/company_csuite_members/${id}/remuneration_components`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      })

    return promise
  }
}

export function loadCgiRemVsPerformance(id, options={}) {
  return (dispatch, getState) => {
    const state = getState()
    dispatch(fetchRemVsPerformanceRequest())

    const promise = api(`api/v1/company_csuite_members/${id}/rem_vs_performance`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchRemVsPerformanceSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchRemVsPerformanceFailure(errors))
        })
      })

    return promise
  }
}

export function loadAbsoluteAlignmentGraphData(id, options={}) {
  return (dispatch, getState) => {
    const state = getState()
    dispatch(fetchAbsoluteAlignmentRequest())

    const promise = api(`api/v1/company_csuite_members/${id}/absolute_alignment`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchAbsoluteAlignmentSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchAbsoluteAlignmentFailure(errors))
        })
      })

    return promise
  }
}

export function loadCgiRemVsPerformancePercentile(id, options={}) {
  return (dispatch, getState) => {
    const state = getState()
    dispatch(fetchRemVsPerformancePercentileRequest())

    const promise = api(`api/v1/company_csuite_members/${id}/rem_vs_performance_percentile`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchRemVsPerformancePercentileSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchRemVsPerformancePercentileFailure(errors))
        })
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true
      })
    case CLEAR_DATA:
      return Object.assign({}, state, {
        result: { },
        loaded: false
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        result: payload
      })
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        result: {
          ...state.result
        },
        errors: errors
      }
    case FETCH_ABSOLUTE_ALIGNMENT_REQUEST:
      return Object.assign({}, state, {
        absoluteAlignmentLoading: true
      })
    case FETCH_ABSOLUTE_ALIGNMENT_SUCCESS:
      return Object.assign({}, state, {
        absoluteAlignmentLoading: false,
        absoluteAlignmentLoaded: true,
        errors: [],
        result: {
          ...state.result, absolute_alignment: payload
        }
      })
    case FETCH_REM_VS_PERFORMANCE_REQUEST:
      return Object.assign({}, state, {
        remVsPerformanceLoading: true
      })
    case FETCH_REM_VS_PERFORMANCE_SUCCESS:
      // need to update pay_vs_performance from result
      return Object.assign({}, state, {
        remVsPerformanceLoading: false,
        remVsPerformanceLoaded: true,
        errors: [],
        result: {
          ...state.result, pay_vs_performance: payload
        }
      })
    case FETCH_REM_VS_PERFORMANCE_FAILURE:
      // need to update pay_vs_performance from result
      return {
        ...state,
        remVsPerformanceLoading: false,
        remVsPerformanceLoaded: false,
        errors: errors
      }
    case FETCH_REM_VS_PERFORMANCE_PERCENTILE_REQUEST:
      return Object.assign({}, state, {
        remVsPerformancePercentileLoading: true
      })
    case FETCH_REM_VS_PERFORMANCE_PERCENTILE_SUCCESS:
      // need to update pay_vs_performance_percentile from result
      return Object.assign({}, state, {
        remVsPerformancePercentileLoading: false,
        remVsPerformancePercentileLoaded: true,
        errors: [],
        result: {
          ...state.result, pay_vs_performance_percentile: payload
        }
      })
    case FETCH_REM_VS_PERFORMANCE_PERCENTILE_FAILURE:
      // need to update pay_vs_performance_percentile from result
      return {
        ...state,
        remVsPerformancePercentileLoading: false,
        remVsPerformancePercentileLoaded: false,
        errors: errors
      }
    default:
      return state
  }
}
